export default __webpack_public_path__ + "static/media/linkedin.1cdd0a13.png";